import { yupResolver } from '@hookform/resolvers/yup'
import axios from 'axios'
import OrangeButton from 'components/Buttons/OrangeButton'
import ErrorMessageWithExclamation from 'components/UI/ErrorMessageWithExclamation'
import VerificationStatus from 'components/verification-status/Verification'
import { BACKEND_REGISTRATION_CODES } from 'constants'
import { getFallbackCountries } from 'constants/fallbackCountries'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useSearchParams } from 'react-router'
import {
  getVerification,
  getVerificationStatus,
  logout,
  setStep,
} from 'routing/fetchingfunction/user/user.action'
import { selectUserData, selectVerificationData } from 'routing/fetchingfunction/user/user.reducer'
import { KYCShema } from 'routing/utils/validators'
import store from 'store'
import shield from '../../../../assets/image/kyc-card.png'
import searchIcon from '../../../../assets/image/searchIcon.png'
import verifiedIcon from '../../../../assets/image/verified-icon.png'
import failedIcon from '../../../../assets/image/failedIcon.png'
import { Button, Loader } from 'components/UI'

const KYC = () => {
  const [countries, setCountries] = useState([])
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [openstatus, setOpenStatus] = useState(false)
  const userData = useSelector(selectUserData)
  const [kycStep, setKycStep] = useState(1)
  const [query] = useSearchParams()
  const statusParams = query.get('verify-status')
  const paramsStatus = query.get('status')
  const sessionIdParams = query.get('verify-status')
  const verifySessionId = query.get('verificationSessionId')

  const [selecetedId] = useState(null)
  const {
    status: isStatus,
    isLoading,
    data,
    error,
    errorList,
  } = useSelector(selectVerificationData)
  const [sessionId, setSessionId] = useState(sessionStorage.getItem('sessionId'))

  console.log(isLoading)
  const nextStepCode = BACKEND_REGISTRATION_CODES.TUTOR_CREATE_BANNER
  const FRONTEND_BASE_URL = (
    process.env.REACT_APP_FRONTEND_BASE_URL || window.location.origin
  ).replace(/\/+$/, '')

  const status = (paramsStatus || isStatus || data?.status || '').toLowerCase()

  useEffect(() => {
    // 1f3946ac-7d7a-4cd7-b349-a78f2cbe11fc
    const storeId = sessionStorage.getItem('sessionId')
    setSessionId(verifySessionId ?? storeId)
  }, [sessionId])

  // useEffect(() => {
  //   if (statusParams) {
  //     console.log(statusParams, '[Step]: Setting up step')
  //     setKycStep(2)
  //   } else {
  //     setKycStep(1)
  //   }
  // }, [statusParams])

  useEffect(() => {
    if (verifySessionId) {
      dispatch(getVerificationStatus(verifySessionId))
      setKycStep(2)
    } else {
      setKycStep(1)
    }
  }, [statusParams, sessionId])

  const handleLogout = async () => {
    try {
      // Dispatch logout and wait for it to complete
      await dispatch(logout()).unwrap()
      //console.log('Logout completed, redirecting to homepage')

      if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.log('Logout completed, redirecting to homepage')
      }

      // Only navigate after logout is complete
      navigate('/')
    } catch (error) {
      console.error('Error during logout:', error)
      // Still try to navigate to homepage even if logout fails
      navigate('/')
    }
  }

  const handleExitRegistration = async () => {
    try {
      // Dispatch logout and wait for it to complete
      await dispatch(logout()).unwrap()
      //console.log('Logout completed, redirecting to homepage')

      if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.log('Logout completed, redirecting to homepage')
      }

      // Only navigate after logout is complete
      navigate('/')
    } catch (error) {
      console.error('Error during logout:', error)
      // Still try to navigate to homepage even if logout fails
      navigate('/')
    }
  }
  useEffect(() => {
    const fetchCountriesFromBackend = async () => {
      try {
        // Try to get countries from the backend first (these will have proper IDs)
        const response = await axios.get('/api/v1/countries/')

        if (response.data && Array.isArray(response.data) && response.data.length > 0) {
          console.log(`Successfully fetched ${response.data.length} countries from backend`)

          // Format data from backend - this preserves the IDs needed for submission
          const formattedData = response.data
            .map((country) => ({
              key: country.id || country.pk, // Backend primary key
              value: country.id || country.pk, // Use ID as value for submission
              label: country.name,
              iso_code: country.iso_3166_1_a2 || country.code || country.iso_code, // Store ISO code
              searchLabel: `${country.name} (${
                country.iso_3166_1_a2 || country.code || country.iso_code
              })`,
            }))
            .sort((a, b) => a.label.localeCompare(b.label))

          setCountries(formattedData)
          setLoading(false)
          return true
        }
        return false
      } catch (error) {
        console.warn(
          'Could not fetch countries from backend, falling back to REST Countries API',
          error
        )
        return false
      }
    }

    // If backend fetch fails, use REST Countries API as fallback
    const fetchCountriesFromRESTAPI = async () => {
      try {
        console.log('Fetching countries from REST Countries API...')

        // Using the all endpoint with name and cca2 fields only
        const response = await fetch('https://restcountries.com/v3.1/all?fields=name,cca2')
        const data = await response.json()

        if (Array.isArray(data) && data.length > 0) {
          // Transform the data into the format needed for dropdowns
          // NOTE: These won't have proper backend IDs, so form submission may fail
          const formattedData = data
            .map((country) => ({
              key: country.cca2,
              value: country.cca2, // This is the ISO code, not the backend PK
              label: country.name.common,
              iso_code: country.cca2,
              searchLabel: `${country.name.common} (${country.cca2})`,
            }))
            .sort((a, b) => a.label.localeCompare(b.label))

          console.log(
            `Successfully loaded ${formattedData.length} countries from REST Countries API`
          )
          setCountries(formattedData)
        } else {
          console.error('REST Countries API returned invalid data', data)
          setCountries(getFallbackCountries())
        }
      } catch (error) {
        console.error('Error fetching countries from REST Countries API:', error)
        setCountries(getFallbackCountries())
      } finally {
        setLoading(false)
      }
    }

    const loadCountries = async () => {
      const backendSuccess = await fetchCountriesFromBackend()
      if (!backendSuccess) {
        await fetchCountriesFromRESTAPI()
      }
    }

    loadCountries()
  }, [])
  const {
    register,
    handleSubmit,
    formState: { errors },
    resetField,
    reset,
    control,
    setValue,
    watch,
  } = useForm({
    resolver: yupResolver(KYCShema),
    defaultValues: {
      country: '',
      documentId: null,
      front_image: null,
      back_image: null,
    },
    mode: 'onChange',
  })

  const handleResetDoc = useCallback(() => {
    reset({
      front_image: null,
      back_image: null,
      documentId: null,
    })
  }, [resetField])

  const handleVerification = () => {
    const freshUserData = store.get('user_data')
    const userId = freshUserData?.id || freshUserData?.pk || userData?.id || userData?.pk

    if (userId) {
      setLoading(true)
      dispatch(
        getVerification({
          callback_url: `${FRONTEND_BASE_URL}/tutor/register/kyc/?verify-status=true'`,
        })
      )
        .unwrap()
        .then((res) => {
          // fe579511-ea88-4335-a1e5-c7294b7cfad6

          // {session_id: 'e3b03ad3-7e00-43f9-b911-63d5a50f2045', session_url: 'https://verify.didit.me/session/Ru8Ks2QAi0wd', verification_id: 38}
          sessionStorage.setItem('sessionId', res?.session_id)
          sessionStorage.setItem('verificationId', res?.verification_id)
          window.location.assign(res?.session_url)
        })
        .catch((err) => {
          console.log(err)
        })
        .finally(() => setLoading(false))

      return
    }
  }
  console.log(status)

  const statusColor = useMemo(
    () => (status === 'verified' || status === 'approved' ? 'text-green-600' : 'text-primary-100'),
    [status]
  )

  const kycTestForm = (
    <>
      <div className="w-full flex flex-col items-center justify-start">
        {error && (
          <div className="!mb-4 text-error-500">
            <p className="font-bold">Following errors occur</p>
            <ErrorMessageWithExclamation text={error} />
          </div>
        )}

        <div className="max-w-xl w-full rounded-2xl px-8 text-center">
          <h1 className={`${statusColor} text-5xl font-semibold`}>
            {status === 'verified' ? 'KYC Document Verified' : 'KYC'}
          </h1>
          <p className="text-[#F67443] text-base text-left">
            To continue, you'll be redirected to our trusted partner to complete your identity
            verification.
          </p>

          <div className="mx-auto max-w-80 w-full h-52 my-16 relative ">
            <img
              src={searchIcon}
              alt="icon verified"
              className="absolute -top-10  -right-10 h-32 w-32"
            />
            <img src={shield} alt="protection shield" className="h-full w-80 m-auto" />
          </div>

          <ul className="text-left -mr-4 -ml-4 space-y-1 mb-2">
            <li className="flex items-start">
              <span className=" mt-1 items-center justify-center rounded-full text-primary-100 text-sm font-semibold mr-3">
                1
              </span>
              <p className="text-primary-150 text-base font-medium">
                Click <span className="font-medium">“Proceed”</span> below to go to Didit’s secure
                verification page.
              </p>
            </li>
            <li className="flex items-start">
              <span className=" mt-1 flex items-center justify-center rounded-full text-primary-100 text-sm font-semibold mr-3">
                2
              </span>
              <p className="text-primary-150 font-medium">
                Complete the required steps (ID upload, selfie check, etc).
              </p>
            </li>
            <li className="flex items-start">
              <span className="shrink-0 mt-1  text-primary-100 text-sm font-semibold mr-3">3</span>
              <p className="text-primary-150 font-medium text-base">
                Once done, you’ll be automatically redirected back to our platform.
              </p>
            </li>
          </ul>

          {!data ? (
            <OrangeButton
              loading={isLoading}
              text={'Proceed to KYC'}
              onClick={handleVerification}
              className="w-full !text-base py-2 px-6 rounded-xl font-medium shadow hover:bg-indigo-700 transition bg-primary-75 text-white my-4"
            />
          ) : status === 'verified' || status === 'approved' ? (
            <OrangeButton
              loading={isLoading}
              text={'Continue to Banner Setup'}
              onClick={() => {
                dispatch(
                  setStep({
                    step: nextStepCode,
                    skipBackendUpdate: true,
                  })
                )
              }}
              className="w-full !text-base py-2 px-6 rounded-xl font-medium shadow hover:bg-indigo-700 transition bg-primary-75 text-white my-4"
            />
          ) : (
            <>
              <p className="text-red-600">KYC verification failed</p>

              <OrangeButton
                loading={isLoading}
                text={'Exit Registration'}
                onClick={handleExitRegistration}
                className="w-full !text-base py-2 px-6 rounded-xl font-medium shadow hover:bg-indigo-700 transition bg-primary-75 text-white my-4"
              />
            </>
          )}

          <p className="text-base  font-medium text-[#F67443] -500 mt-0">
            The process is safe, quick, and your data stays protected.{' '}
          </p>
        </div>
      </div>
    </>
  )

  const errorMessage = useCallback(
    (errorMessage) => {
      switch (errorMessage) {
        case 'liveness':
          return 'Failed liveness test'
        case 'name_verification':
          return 'Name on ID does not match entered details'
        case 'ip_analysis':
          return 'IP analysis failed'
        case 'id_verification':
          return 'Details on ID does not match entered details'
        case 'face_match_Warning':
          return "The facial features of the provided  don't  match"

        case 'unsupported_document':
          return 'Unsupported ID type'
        case 'unsupported_document_type':
          return 'Blurry or unreadable ID document'
        case 'face_match':
          return 'Face does not match uploaded ID photo'
        case 'unreadable_document':
          return 'Blurry or unreadable ID document'

        default:
          return ''
      }
    },
    [data]
  )
  const kycVerificationStatus = (
    <>
      {isLoading ? (
        <Loader />
      ) : status === 'verified' || status === 'approved' ? (
        <>
          <h2 className="text-5xl font-extrabold text-center text-[#FF9053] ">KYC Approved</h2>
          <p className="text-primary-75 mt-2 text-center text-lg">Your verification is complete</p>
          <p className="text-primary-75 mt-1 text-center text-lg">
            {' '}
            Thank you for taking the time!
          </p>
          <div className="mx-auto max-w-80 w-full h-52 my-16 relative ">
            <img
              src={verifiedIcon}
              alt="icon verified"
              className="absolute -top-10  -right-10 h-32 w-32"
            />
            <img src={shield} alt="protection shield" className="h-full w-80 m-auto" />
          </div>
          <p className="text-primary-75 mt-2 font-normal text-xl">
            You can now set up your banner to get started.
          </p>

          <div className="flex w-full my-10 gap-4">
            <Button
              onClick={() => {
                dispatch(
                  setStep({
                    step: nextStepCode,
                    skipBackendUpdate: true,
                  })
                )
              }}
              className="flex-1  bg-primary-75 rounded-lg  m-auto max-w-lg py-2 text-white font-semibold border"
            >
              Continue to Banner Setup
            </Button>
          </div>
        </>
      ) : (
        <>
          {error && (
            <div className="!mb-4 text-error-500">
              <p className="font-bold">Following errors occur</p>
              <ErrorMessageWithExclamation text={error} />
            </div>
          )}{' '}
          <h2 className="text-4xl font-semibold text-[#FF9053]">Verification Unsuccessful</h2>
          <p className="text-primary-75 font-normal mt-2 text-lg ">
            We weren’t able to complete your KYC verification this time. If we need more details,
            we’ll reach out to you. For now, your sign-up is on hold.{' '}
          </p>
          <div className="mx-auto max-w-80 w-full h-52 my-16 relative ">
            <img
              src={failedIcon}
              alt="icon verified"
              className="absolute -top-10  -right-10 h-32 w-32"
            />
            <img src={shield} alt="protection shield" className="h-full w-80 m-auto" />
          </div>
          <ul className="list-disc max-w-sm m-auto list-inside space-y-2 text-gray-700 mb-6">
            {[
              'Name on ID does not match entered details',
              'Failed liveness test',
              'Face does not match uploaded ID photo',
              'Blurry or unreadable ID document',
              'Unsupported ID type',
            ].map((message, index) => (
              <li className={'text-primary-75 text-base my-1 text-left'} key={index}>
                {message}
                {/* {errorMessage(field)} */}
              </li>
            ))}
          </ul>
          <div className="flex w-full  justify-center items-center mx-auto   my-4 gap-4">
            <Button
              loading={isLoading}
              // onClick={handleVerification}
              onClick={() => setKycStep(1)}
              className="w-full bg-white !text-primary-100 shadow border !border-primary-100"
            >
              Back
            </Button>

            <Button isLoading={loading} onClick={handleLogout} className="w-full shadow">
              Log Out
            </Button>
          </div>
        </>
      )}
    </>
  )

  const kycProcess = useMemo(() => {
    switch (kycStep) {
      case 1:
        return kycTestForm
      case 2:
        return kycVerificationStatus
      default:
        return kycTestForm
    }
  }, [kycStep, status, isLoading])

  return (
    <>
      <div className="max-w-[800px]  rounded-xl w-full text-center  my-4 bg-[#FEEBDD] md:px-24 py-12 mx-auto  !text-primary-100">
        {' '}
        {kycProcess}
      </div>
      <VerificationStatus
        open={openstatus}
        setOpen={setOpenStatus}
        data={data}
        IDType={selecetedId?.label}
      />
    </>
  )
}

export default KYC
